var scope_0 = require('/Users/broarr/src/decks/enhancing-reproducibility-with-containers/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d115fed65102cc1dcc7a1211d3d70ac2.js').default;export default
        Object.assign({}, scope_0 )
    